/**
 * Created by Ivan on 07.07.2026
 */

const StickersCompletedWindow = Prefab.createWindow("stickers_completed_window", "stickers_completed_window_prefab_json", {
    bundles: (index) => [cleverapps.stickersBook.collectionBundle(index)]
});
